import React, { useState, useEffect } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import { useInView } from "react-intersection-observer";
import TR from './../../Trans';
import MenuIcon from '@mui/icons-material/Menu';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Menu from '@mui/material/Menu';
import AlbumIcon from '@mui/icons-material/Album';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import settingsStore from '../../stores/settings';
import sessionStore from './../../stores/session';
import bgPerformanceStore from '../../stores/bgPerformance';
import favoritesStore from '../../stores/favorites';
import playerStore from '../../stores/player';
import musicPlayerStore from '../../stores/musicPlayer';

function BackgroundMusicPeekListItem(props) {

  const thisPerformance = bgPerformanceStore((state) => state.playLists?.find(x => x.id == props.playListId)?.items?.find(x => x.position == props.index));
  const sessionToken = sessionStore((state) => state.sessionToken);
  const currentTrack = musicPlayerStore((state) => state.currentTrack);
  const isPaused = musicPlayerStore((state) => state.isPaused);
  const isPlayerStopped = playerStore((state) => state.isStopped);
  const settings = settingsStore((state) => state.settings);
  const performanceToBeChanged = bgPerformanceStore((state) => state.performanceToBeChanged);
  const moveUpInPlayList = bgPerformanceStore((state) => state.moveUpInPlayList);
  const moveDownInPlayList = bgPerformanceStore((state) => state.moveDownInPlayList);
  const moveToTopInPlayList = bgPerformanceStore((state) => state.moveToTopInPlayList);
  const moveToSecondInPlayList = bgPerformanceStore((state) => state.moveToSecondInPlayList);
  const moveToBottomInPlayList = bgPerformanceStore((state) => state.moveToBottomInPlayList);
  const deletePerformanceInPlayList = bgPerformanceStore((state) => state.deletePerformanceInPlayList);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuClose = () => {
    setMenuOpen(false);
    props.onMenuClose();
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleMoveToTop = () => {
    moveToTopInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const handleMoveToSecond = () => {
    moveToSecondInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const handleMoveToBottom = () => {
    moveToBottomInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const handleMoveUp = () => {
    moveUpInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const handleMoveDown = () => {
    moveDownInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const renderMoveToFirst = () => {
    if (thisPerformance?.position > 0) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveToTop();
        handleMenuClose();
      }}>{TR.cm_move_to_top}</MenuItem>;
    }
  };

  const renderMoveToSecond = () => {
    if (props.count > 1 && thisPerformance?.position != 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveToSecond();
        handleMenuClose();
      }}>{TR.cm_move_to_second}</MenuItem>;
    }
  };

  const renderMoveUp = () => {
    if (thisPerformance?.position > 0) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveUp();
        handleMenuClose();
      }}>{TR.cm_move_up}</MenuItem>;
    }
  };

  const renderMoveDown = () => {
    if (thisPerformance?.position < props.count - 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveDown();
        handleMenuClose();
      }}>{TR.cm_move_down}</MenuItem>;
    }
  };

  const renderMoveToLast = () => {
    if (thisPerformance?.position < props.count - 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMoveToBottom();
        handleMenuClose();
      }}>{TR.cm_move_to_bottom}</MenuItem>;
    }
  };

  const renderDelete = () => {
    return <MenuItem onClick={(e) => {
      e.stopPropagation();
      deletePerformanceInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
      handleMenuClose();
    }}>{TR.cm_delete}</MenuItem>;
  };

  const primaryText = () => {
    return <div>
      {(thisPerformance?.position + 1)}. {thisPerformance?.track.title}
    </div>;
  };

  const secondaryText = thisPerformance?.track.artist;

  const handleItemClick = (e) => {
    if (performanceToBeChanged) {
      props.onChangeTrackPerformance(e, thisPerformance);
    } else {
      props.onEditPerformance(thisPerformance);
    }
  };

  const renderAvatar = () => {
    if (currentTrack) {
      if (thisPerformance?.track.track_id === currentTrack.track_id && !isPaused.isPaused && isPlayerStopped.isStopped) {
        return <ListItemAvatar className="muvika-track-avatar-item">
          <ListItemIcon>
            <div>
              <img className="muvika-icon performance-list-item-icon" src="./eq.gif" />
            </div>
          </ListItemIcon>
        </ListItemAvatar>;
      } else {
        return <ListItemAvatar className="muvika-track-avatar-item">
          <ListItemIcon>
            <AlbumIcon />
          </ListItemIcon>
        </ListItemAvatar>;
      }
    } else {
      return <ListItemAvatar className="muvika-track-avatar-item">
        <ListItemIcon>
          <AlbumIcon />
        </ListItemIcon>
      </ListItemAvatar>;
    }
  };

  const renderPlayButton = () => {
    return <IconButton color="white" component="label" size="large" onClick={(e) => {
      e.stopPropagation();
      props.onPlayNow(thisPerformance);
    }}>
      <PlayArrowIcon />
    </IconButton>;
  };

  const renderMenuButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <IconButton
          id={"menu-button-" + thisPerformance?.unique_id}
          color="white"
          component="label"
          size="small"
          aria-controls={isMenuOpen ? "menu-" + thisPerformance?.unique_id : undefined}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? 'true' : undefined}
          onClick={(e) => {
            e.stopPropagation();
            openMenu(e);
          }} >
          <MenuIcon />
        </IconButton>;
      }
    }
  };

  const renderButton = () => {
    if (thisPerformance) {
      console.log("render again");
      return <ListItemButton sx={{
        marginLeft: "1.2rem",
        bgcolor: isMenuOpen ? 'rgba(255, 255, 255, 0.08)' : 'unset'
      }}
        onClick={(e) => {
          handleItemClick(e);
        }}>
        {renderAvatar()}
        <ListItemText primary={primaryText()} secondary={secondaryText} />
        <ListItemText className="muvika-list-right-playlists" secondary={thisPerformance?.track.kcode} />
        {renderPlayButton()}
        {renderMenuButton()}
        <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus  
          id={"menu-" + thisPerformance?.unique_id}
          open={isMenuOpen}
          anchorEl={anchorEl}
          onClose={(e) => {
            e.stopPropagation();
            handleMenuClose();
          }}
          MenuListProps={{
            'aria-labelledby': 'menu-button-' + thisPerformance?.unique_id,
          }}
        >
          <MenuItem onClick={(e) => {
            e.stopPropagation();
            handleMenuClose();
            props.onEditPerformance(thisPerformance);
          }}>{TR.cm_edit}</MenuItem>
          {renderMoveToFirst()}
          {renderMoveToSecond()}
          {renderMoveUp()}
          {renderMoveDown()}
          {renderMoveToLast()}
          {renderDelete()}
        </Menu>
      </ListItemButton>;
    }
  };

  return (
    <Draggable key={props.key} draggableId={props.draggableId} index={props.index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {renderButton()}
        </div>
      )}
    </Draggable>
  );
}

export default BackgroundMusicPeekListItem;